export default __webpack_public_path__ + "static/media/home2.ae7bf2b0.png";